import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { handleSaveProjectClick } from 'EnvironmentModule/actions/project';
import Modal from '@/components/Modals/Modal';
import { ModalBodyStyled, InputStyled } from './styles';

const SaveProjectAsModal = props => {
  const { setOpen } = props;
  const dispatch = useDispatch();
  const projectName = useSelector(state => state.core.projectName);
  const [value, setValue] = React.useState(projectName || '');
  const inputRef = React.useRef(null);

  const handleChange = e => {
    setValue(e.target.value);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleApply = () => {
    if (value) {
      dispatch(handleSaveProjectClick(value));
      handleClose();
    }
  };

  return (
    <Modal
      open
      setOpen={setOpen}
      handleClose={handleClose}
      handleApply={handleApply}
      height="150px"
      title={<FormattedMessage id="app.editor.modal.saveProjectAs" defaultMessage="Save project as" />}
    >
      <ModalBodyStyled>
        <InputStyled
          type="text"
          error={false}
          value={value}
          disabled={false}
          ref={inputRef}
          onChange={handleChange}
          onFocus={() => {
            if (inputRef.current) {
              inputRef.current.select();
            }
          }}
        />
      </ModalBodyStyled>
    </Modal>
  );
};

export default SaveProjectAsModal;
